// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"67a5d18e","361":"6eeb6f4f","511":"ffaf7465","767":"c186235e"}[chunkId] + ".chunk.js";
};